import React, { useMemo } from 'react';
import cn from 'classnames';
import './profile.scss';

interface ProfileAvatarProps {
    url?: string;
    name: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    onClick?: () => void;
}

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
    url,
    name,
    size = 'md',
    className,
    onClick
}) => {
    // İsimden baş harfleri al
    const initials = useMemo(() => {
        if (!name) return '?';
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }, [name]);

    // Rastgele arka plan rengi seç (isime göre tutarlı)
    const bgClass = useMemo(() => {
        const colors = [
            'bg-blue', 'bg-green', 'bg-yellow',
            'bg-red', 'bg-purple', 'bg-pink', 'bg-indigo'
        ];
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    }, [name]);

    return (
        <div
            className={cn(
                'profile-avatar',
                size,
                !url && bgClass,
                className
            )}
            onClick={onClick}
        >
            {url ? (
                <img
                    src={url}
                    alt={name}
                    onError={(e) => {
                        // Resim yüklenemezse fallback olarak baş harfleri göster
                        e.currentTarget.style.display = 'none';
                        e.currentTarget.parentElement?.classList.add(bgClass);
                        // Span'ı görünür yap
                        const span = e.currentTarget.parentElement?.querySelector('span');
                        if (span) span.style.display = 'block';
                    }}
                />
            ) : null}
            <span style={{ display: url ? 'none' : 'block' }}>
                {initials}
            </span>
        </div>
    );
};
